import { render, staticRenderFns } from "./UsuarioCompras.vue?vue&type=template&id=2b63b34c&scoped=true&"
import script from "./UsuarioCompras.vue?vue&type=script&lang=js&"
export * from "./UsuarioCompras.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioCompras.vue?vue&type=style&index=0&id=2b63b34c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b63b34c",
  null
  
)

export default component.exports